import { useTranslation } from 'react-i18next';
import { EngagementForInsightCheck } from '@anytag/graphql';
import { TableCell } from '@anytag/shared-atoms';
import { useTranslateCountry } from '@anytag/shared-hooks';
import { SpreadButton } from '@anytag/shared-molecules';
import { formatIntNumber } from '@anytag/shared-utils';
import { ColumnDef } from '@tanstack/react-table';
import { PostInsightStatus } from '../../PostInsightStatus';

export const usePostsInsightListTable = () => {
  const { t } = useTranslation();
  const { tc } = useTranslateCountry();

  const columns: ColumnDef<EngagementForInsightCheck>[] = [
    {
      accessorKey: 'title',
      header: t<string>('HeaderColumn.Campaign'),
      cell: ({ row }) => (
        <TableCell.Link
          to="/posts-insight/$id"
          params={{ id: row.original.id.toString() }}
          label={row.original.title}
        />
      )
    },
    {
      accessorKey: 'countries',
      header: t<string>('HeaderColumn.Country'),
      cell: ({ row }) => (
        <TableCell.Text
          className="min-w-0"
          value={
            row.original.countries.length > 0 ? row.original.countries.map(({ name }) => tc(name)).join(', ') : '-'
          }
        />
      )
    },
    {
      accessorKey: 'startDate',
      header: t<string>('HeaderColumn.Campaign Duration'),
      cell: ({ row }) => (
        <TableCell.Period period={{ startDate: row.original.startDate, endDate: row.original.endDate }} />
      )
    },
    {
      accessorKey: 'totalSubmissions',
      header: t<string>('HeaderColumn.Number of Submissions'),
      cell: ({ row }) => (
        <span>
          <span className="text-lg">{formatIntNumber(row.original.totalConfirmations)}</span>/
          <span className="text-base">{formatIntNumber(row.original.totalSubmissions)}</span>
        </span>
      )
    },
    {
      size: 50, // to let width max content
      accessorKey: 'status',
      header: t<string>('HeaderColumn.Status'),
      meta: { align: 'center' },
      cell: ({ row }) => (
        <PostInsightStatus
          status={row.original.status}
          css={{ height: '24px', fontSize: '12px', padding: '5px 12px', minWidth: '105px', margin: 'auto' }}
        />
      )
    },
    {
      size: 48,
      accessorKey: 'actions',
      header: '',
      cell: ({ row }) => (
        <SpreadButton
          options={[
            {
              icon: 'edit',
              label: t('Edit'),
              tooltip: { help: t('Button.Edit') },
              to: '/posts-insight/$id',
              params: { id: row.original.id.toString() }
            }
          ]}
        />
      )
    }
  ];

  return { columns };
};
